import * as React from "react";
import type { FC, PropsWithChildren, ReactNode } from "react";
import { XIcon16Solid } from "@skbkontur/icons/XIcon16Solid";
import { KonturColors } from "@skbkontur/colors";

import { Caption, CloseIcon, Description, Layout, Body, Underline } from "./ConvertationInfo.styles";

interface FrameProps {
    onClose: () => void;
    description: ReactNode;
}

type InstanceProps = Pick<FrameProps, "onClose">;

const ErrorFrame: FC<PropsWithChildren<FrameProps>> = props => (
    <Layout>
        <XIcon16Solid color={KonturColors.mainErrorShapeRed60} />
        <Body>
            <Caption>Не удалось загрузить файл</Caption>
            {props.description}
        </Body>
        <CloseIcon onClick={props.onClose} />
    </Layout>
);

export const Failed: FC<InstanceProps> = props => (
    <ErrorFrame
        onClose={props.onClose}
        description={
            <>
                <Description paragraph={false}>
                    Нам не удалось конвертировать ваш файл в требуемый формат <Underline>PDF/A-1 версии 1.4.</Underline>
                </Description>
                <Description>Проверьте файл и повторите попытку</Description>
            </>
        }
    />
);

export const ServerError: FC<InstanceProps> = props => (
    <ErrorFrame
        onClose={props.onClose}
        description={
            <Description>Попробуйте еще раз позже. Если проблема сохраняется, напишите в поддержку</Description>
        }
    />
);
